import { writable } from 'svelte/store';
export let totalCount = writable(0);
